/**
 * 礼物表（自由出行批：礼品店道具版礼物，设计基准 docs/自由出行与小地图-设计方案.md §五）
 *
 * 2026-10-11 拍板：4 类 × 3 档 = 12 件；价格 200/2000/10000 → 好感 +2/+5/+8；
 * 送中 NPC 喜好类别 → 好感 ×2（+4/+10/+16，通胀由价格闸门兜底）；回礼机制照旧
 * （好感≥60 好友 20% / ≥80 挚友 35% 概率回 30% 价格）。
 * 送礼入口两处（⛔ 不设月限）：人脉页 🎁 / 偶遇 VN 条件选项；唯一进货渠道 = 心意礼品店（周末商业街）。
 * 取代旧 Items.ts 最小礼物表（原「手工曲奇 +6」测试档作废；曲奇保留进表，老档背包不悬空）。
 *
 * ⚠️ 名称/emoji 为占位草案——价目表与名称清单归《自由出行文案填写表》（茄子改定后回填，⛔ 改 id）。
 */

/** 礼物类别（= NPC 喜好类别：cheerful→零食 / quiet→文创 / sharp→饰品 / warm→护肤，草案） */
export type GiftCategory = 'acc' | 'snack' | 'stationery' | 'skincare';

export const GIFT_CATEGORY_LABELS: Record<GiftCategory, string> = {
    acc: '饰品',
    snack: '零食',
    stationery: '文创',
    skincare: '护肤',
};

export interface GiftDef {
    id: string;
    /** 上屏名（送礼选项文案与 `%s` 反应句都读它） */
    name: string;
    emoji: string;
    category: GiftCategory;
    /** 价签（心意礼品店售价；回礼回款 = price × 0.3） */
    price: number;
    /** 送出好感基准（送中喜好 ×2 在 SocialSystem 结算） */
    favor: number;
}

export const GIFTS: GiftDef[] = [
    // ===== 饰品（sharp 喜好） =====
    { id: 'hairband', name: '丝绒发圈', emoji: '🎀', category: 'acc', price: 200, favor: 2 },
    { id: 'pearl_brooch', name: '珍珠胸针', emoji: '🧿', category: 'acc', price: 2000, favor: 5 },
    { id: 'necklace_custom', name: '定制项链', emoji: '📿', category: 'acc', price: 10000, favor: 8 },
    // ===== 零食（cheerful 喜好） =====
    { id: 'cookies', name: '手工曲奇', emoji: '🍪', category: 'snack', price: 200, favor: 2 },
    { id: 'chocolate', name: '精装巧克力', emoji: '🍫', category: 'snack', price: 2000, favor: 5 },
    { id: 'dessert_voucher', name: '限量甜品券', emoji: '🍰', category: 'snack', price: 10000, favor: 8 },
    // ===== 文创（quiet 喜好） =====
    { id: 'washi_tape', name: '手账胶带', emoji: '📎', category: 'stationery', price: 200, favor: 2 },
    { id: 'art_book', name: '绝版画册', emoji: '📕', category: 'stationery', price: 2000, favor: 5 },
    { id: 'signed_edition', name: '艺术家签名版', emoji: '🖼️', category: 'stationery', price: 10000, favor: 8 },
    // ===== 护肤（warm 喜好） =====
    { id: 'hand_cream', name: '护手霜', emoji: '🧴', category: 'skincare', price: 200, favor: 2 },
    { id: 'perfume_set', name: '香水礼盒', emoji: '💐', category: 'skincare', price: 2000, favor: 5 },
    { id: 'skincare_lux', name: '高定护肤套装', emoji: '🎁', category: 'skincare', price: 10000, favor: 8 },
];

export const GIFT_MAP: Record<string, GiftDef> = {};
GIFTS.forEach(g => { GIFT_MAP[g.id] = g; });

/** 开局发放量（老档迁移与新档 init 共用：让偶遇「送礼」格开局即可测；正式进货=礼品店） */
export const STARTER_GIFTS: { id: string; count: number }[] = [
    { id: 'cookies', count: 10 },
];
